import { Segment } from '../../../services/types';
import { MerchantsState } from '../merchants/types';

/**
 * Action types
 * @HANDLE_MERCHANTS insert merchants
 * @HANDLE_SEGMENTS insert segments
 * @FILTER_MERCHANT filter merchants for chars
 * @FILTER_SEGMENT filter merchants by segments
 * @HANDLE_POSITION filter merchants by position
 */

export enum MarketsTypes {
  HANDLE_MERCHANTS = '@marketplace/HANDLE_MERCHANTS',
  HANDLE_SEGMENTS = '@marketplace/HANDLE_SEGMENTS',
  FILTER_MERCHANT = '@marketplace/FILTER_MERCHANT',
  FILTER_SEGMENT = '@marketplace/FILTER_SEGMENT',
  HANDLE_POSITION = '@marketplace/HANDLE_POSITION',
  UPDATE_MERCHANT_AVAILABILITY = '@marketplace/UPDATE_MERCHANT',
}
/**
 * State type
 * @merchantsList : list of merchants
 * @segmentsList : list of segments
 * @searchBar : string to filter
 * @filterSegment : segment to filter
 * @city : city
 * @state : wow
 */
export interface MarketsState {
  merchantsList: MerchantsState[];
  segmentsList: Segment[];
  searchBar: string;
  filterSegment: string;
  city: string;
  state: string;
}
